export default (text, limit) => {
  if (text && text.length > limit) {
    return text.slice(0, limit).concat('...');
  }

  return text;
};
